<template>
  <div class="camp-product-page">
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item>位置：</el-breadcrumb-item>
      <el-breadcrumb-item>微信管理</el-breadcrumb-item>
      <el-breadcrumb-item>微商城</el-breadcrumb-item>
      <el-breadcrumb-item>{{ pageTitle }}</el-breadcrumb-item>
    </el-breadcrumb>

    <div class="head-card">
      <div class="head-top">
        <div class="head-title">{{ pageTitle }}</div>
        <div class="head-meta">
          产品分类：营地课程　产品类目：-全部-　产品ID：{{ productIdDisplay }}
        </div>
        <i class="el-icon-close head-close" @click="goBack"></i>
      </div>

      <div class="step-bar">
        <template v-for="(item, index) in steps">
          <div
            :key="'step-' + item.value"
            class="step-item"
            :class="stepClass(item.value)"
          >
            <div class="step-circle">
              <span>{{ index + 1 }}</span>
            </div>
            <div class="step-text">
              <div class="step-label">{{ item.label }}</div>
              <div class="step-status">{{ stepStatusText(item.value) }}</div>
            </div>
          </div>
          <div
            v-if="index < steps.length - 1"
            :key="'line-' + item.value"
            class="step-line"
            :class="{ done: stepIndex > item.value }"
          ></div>
        </template>
      </div>
    </div>

    <div class="body-card">
      <div class="body-inner">
      <el-form
        ref="formRef"
        :model="form"
        label-position="top"
        class="camp-form"
      >
        <!-- 步骤1 产品详情 -->
        <div v-show="stepIndex === 1" class="step1-form">
          <el-form-item label="产品名称" required>
            <el-input v-model="form.product_name" placeholder="请输入产品名称" maxlength="100"></el-input>
          </el-form-item>
          <el-form-item label="产品主图" required>
            <el-upload
              action="http://xwt.softykt.net/api/product/uploadInfoRemit"
              list-type="picture-card"
              :limit="5"
              :class="hideUpload ? 'hide-upload' : ''"
              :data="uploadData"
              :file-list="coverFileList"
              :on-success="onCoverSuccess"
              :on-remove="onCoverRemove"
              :on-exceed="onCoverExceed"
            >
              <i class="el-icon-plus"></i>
            </el-upload>
            <div class="tip-text">
              最多上传5个资源；建议比例 1:1；支持 jpg / png，单张不超过 300kb；视频资源可后续扩展，当前仅支持图片上传。
            </div>
          </el-form-item>
          <el-form-item label="产品详情" required>
            <div class="rich-editor">
              <quill-editor
                v-model="form.product_desc"
                ref="productDescEditor"
              ></quill-editor>
            </div>
            <div class="tip-text">
              例：【使用人群】适合6-12岁儿童　【课程亮点】户外拓展、团队协作　【注意事项】请自备防晒用品
            </div>
          </el-form-item>
          <el-form-item label="营期行程" required>
            <div
              v-for="(dayItem, dayIdx) in itineraryDays"
              :key="'day-' + dayItem.day"
              class="day-block"
            >
              <div class="day-title">DAY{{ dayItem.day }}</div>
              <div
                v-for="(row, rowIdx) in dayItem.list"
                :key="'itinerary-' + dayIdx + '-' + rowIdx"
                class="itinerary-grid-wrap"
              >
                <div class="itinerary-grid">
                  <div class="grid-cell">
                    <div class="grid-label">时间点</div>
                    <el-time-select
                      v-model="row.time_point"
                      :picker-options="{ start: '00:00', step: '00:15', end: '23:45' }"
                      placeholder="HH:mm"
                      style="width: 100%"
                    ></el-time-select>
                  </div>
                  <div class="grid-cell">
                    <div class="grid-label">行程名称</div>
                    <el-input v-model="row.title" placeholder="请输入行程名称"></el-input>
                  </div>
                  <div class="grid-cell">
                    <div class="grid-label">行程内容</div>
                    <el-input v-model="row.content" placeholder="请输入行程内容"></el-input>
                  </div>
                  <div class="grid-cell">
                    <div class="grid-label">行程时间</div>
                    <el-input v-model="row.duration" placeholder="请输入" type="number">
                      <template slot="append">小时</template>
                    </el-input>
                  </div>
                </div>
                <div class="itinerary-row-actions">
                  <el-button
                    v-if="rowIdx === dayItem.list.length - 1"
                    @click="addItineraryRow(dayIdx)"
                  >添加新行程</el-button>
                  <el-button
                    type="danger"
                    :disabled="totalItineraryCount <= 1"
                    @click="removeItineraryRow(dayIdx, rowIdx)"
                  >删除</el-button>
                </div>
              </div>
              <div
                v-if="dayIdx === itineraryDays.length - 1"
                class="day-actions"
              >
                <el-button type="primary" class="btn-primary" @click="addItineraryDay">添加营期日期</el-button>
              </div>
            </div>
          </el-form-item>
        </div>

        <!-- 步骤2 日期设置 -->
        <div v-show="stepIndex === 2" class="step2-form">
          <el-form-item label="销售日期" required>
            <el-date-picker
              v-model="saleRange"
              type="daterange"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              value-format="yyyy-MM-dd"
              :clearable="false"
              class="full-width-picker"
            ></el-date-picker>
          </el-form-item>

          <el-form-item label="营期设置" required>
            <div
              v-for="(camp, cIdx) in form.product_date_arr"
              :key="'camp-' + cIdx"
              class="camp-card"
            >
              <div class="camp-card-head">
                <span>营期 {{ cIdx + 1 }}</span>
                <el-button
                  type="danger"
                  :disabled="form.product_date_arr.length <= 1"
                  @click="removeCamp(cIdx)"
                >删除</el-button>
              </div>
              <div class="camp-card-body">
                <div class="camp-field">
                  <span class="inline-label">营期名称</span>
                  <el-input v-model="camp.date_name" placeholder="请输入营期名称"></el-input>
                </div>
                <div class="camp-field">
                  <span class="inline-label">营期时间</span>
                  <el-date-picker
                    v-model="camp.campRange"
                    type="daterange"
                    range-separator="至"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期"
                    value-format="yyyy-MM-dd"
                    :clearable="false"
                    :picker-options="campDatePickerOptions"
                    class="full-width-picker"
                  ></el-date-picker>
                </div>
                <div class="camp-field-row">
                  <div class="camp-field flex-1">
                    <span class="inline-label">销售价</span>
                    <el-input v-model="camp.sale_price" type="number" placeholder="请输入">
                      <template slot="append">元</template>
                    </el-input>
                  </div>
                  <div class="camp-field flex-1">
                    <span class="inline-label">市场价</span>
                    <el-input v-model="camp.market_price" type="number" placeholder="请输入">
                      <template slot="append">元</template>
                    </el-input>
                  </div>
                  <div class="camp-field flex-1">
                    <span class="inline-label label-wide">库存人数</span>
                    <el-input v-model="camp.stock_num" type="number" placeholder="请输入">
                      <template slot="append">人</template>
                    </el-input>
                  </div>
                </div>
                <div class="camp-field">
                  <span class="inline-label">是否上架</span>
                  <el-radio-group v-model="camp.is_online">
                    <el-radio :label="1">上架</el-radio>
                    <el-radio :label="0">暂不上架</el-radio>
                  </el-radio-group>
                </div>
              </div>
            </div>
            <div class="step2-actions">
              <el-button type="primary" class="btn-primary" @click="addCamp">添加营期</el-button>
            </div>
          </el-form-item>

          <el-form-item label="规格设置" required>
            <div class="spec-box">
              <div
                v-for="(group, gIdx) in form.spec_group_arr"
                :key="'spec-group-' + gIdx"
                class="spec-group"
              >
                <div class="camp-field">
                  <span class="inline-label">规格标题</span>
                  <el-input
                    v-model="group.group_title"
                    placeholder="请输入"
                  ></el-input>
                  <el-button
                    v-if="form.spec_group_arr.length > 1"
                    type="danger"
                    @click="removeSpecGroup(gIdx)"
                  >删除</el-button>
                </div>
                <div
                  v-for="(item, iIdx) in group.item_list"
                  :key="'spec-item-' + gIdx + '-' + iIdx"
                  class="spec-item-row"
                >
                  <div class="camp-field spec-name">
                    <span class="inline-label">内容名称</span>
                    <el-input v-model="item.item_name" placeholder="请输入"></el-input>
                  </div>
                  <div class="camp-field spec-stock">
                    <span class="inline-label">库存</span>
                    <el-input v-model="item.stock_num" type="number" placeholder="请输入"></el-input>
                  </div>
                  <div class="camp-field spec-fee">
                    <span class="inline-label">附赠费用</span>
                    <el-input v-model="item.extra_price" type="number" placeholder="请输入">
                      <template slot="append">元</template>
                    </el-input>
                  </div>
                  <el-button
                    class="spec-del-btn"
                    :disabled="group.item_list.length <= 1"
                    @click="removeSpecItem(gIdx, iIdx)"
                  >删除</el-button>
                </div>
                <div class="step2-actions">
                  <el-button type="primary" class="btn-primary" @click="addSpecItem(gIdx)">新增内容</el-button>
                </div>
                <div v-if="gIdx < form.spec_group_arr.length - 1" class="spec-divider"></div>
              </div>
              <div class="spec-footer">
                <el-button type="primary" class="btn-primary" @click="addSpecGroup">新增规格</el-button>
              </div>
            </div>
          </el-form-item>

          <el-form-item label="开课提示" required>
            <div class="remind-row">
              <el-radio-group v-model="form.remind_enable">
                <el-radio :label="0">不提示</el-radio>
                <el-radio :label="1">提示</el-radio>
              </el-radio-group>
              <el-input
                v-if="form.remind_enable === 1"
                v-model="form.remind_days"
                type="number"
                placeholder="请输入数字"
                class="remind-input"
              >
                <template slot="append">天前提示</template>
              </el-input>
            </div>
          </el-form-item>
        </div>

        <!-- 步骤3 下单设置 -->
        <div v-show="stepIndex === 3" class="step3-form">
          <el-form-item label="押金设置" required>
            <el-checkbox-group v-model="depositTypes">
              <el-checkbox :label="1">线下押金</el-checkbox>
              <el-checkbox :label="2">线上押金</el-checkbox>
            </el-checkbox-group>
          </el-form-item>
          <el-form-item label="下单信息" required>
            <div class="need-fields-box">
              <div
                v-for="item in needFieldOptions"
                :key="item.value"
                class="need-field-row"
              >
                <el-checkbox
                  :value="isNeedFieldChecked(item.value)"
                  @input="toggleNeedField(item.value, $event)"
                >{{ item.label }}</el-checkbox>
                <el-radio-group
                  v-if="isNeedFieldChecked(item.value)"
                  :value="getNeedFieldRequired(item.value)"
                  size="mini"
                  @input="setNeedFieldRequired(item.value, $event)"
                >
                  <el-radio :label="1">必填</el-radio>
                  <el-radio :label="0">选填</el-radio>
                </el-radio-group>
              </div>
            </div>
          </el-form-item>
          <!-- 信息通知不展示，固定传短信通知 -->
        </div>

        <!-- 步骤4 退款设置 -->
        <div v-show="stepIndex === 4" class="step4-form">
          <el-form-item label="退款设置" required>
            <div class="refund-box">
              <div
                v-for="(rule, rIdx) in form.refund_rule_arr"
                :key="'refund-' + rIdx"
                class="refund-row"
              >
                <div class="camp-field refund-days">
                  <span class="inline-label">退款时间</span>
                  <el-input
                    v-model="rule.days"
                    type="number"
                    placeholder="请输入数字"
                  >
                    <template slot="prepend">≥</template>
                    <template slot="append">日</template>
                  </el-input>
                </div>
                <div class="camp-field refund-rate">
                  <span class="inline-label">扣费比例</span>
                  <el-input
                    v-model="rule.deduct_rate"
                    type="number"
                    placeholder="可设置到小数点后两位"
                  >
                    <template slot="append">%</template>
                  </el-input>
                </div>
                <el-button
                  v-if="form.refund_rule_arr.length > 1"
                  class="spec-del-btn"
                  @click="removeRefundRule(rIdx)"
                >删除</el-button>
              </div>
              <div class="step2-actions">
                <el-button class="btn-outline" @click="addRefundRule">添加档位</el-button>
              </div>
            </div>
          </el-form-item>
          <el-form-item label="上架设置" required>
            <el-radio-group v-model="form.is_online">
              <el-radio :label="1">上架</el-radio>
              <el-radio :label="0">暂不上架</el-radio>
            </el-radio-group>
          </el-form-item>
        </div>
      </el-form>

      <div class="footer-btns">
        <el-button v-if="stepIndex > 1" @click="prevStep">上一步</el-button>
        <el-button @click="resetCurrentStep">重置</el-button>
        <el-button
          type="primary"
          class="btn-primary"
          :loading="submitting"
          @click="nextOrSubmit"
        >{{ footerBtnText }}</el-button>
      </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Message } from 'element-ui'
import { campProductStore, campProductRedact, campProductDetail } from '@/request/scenic.js'

function createEmptyItineraryRow() {
  return {
    time_point: '',
    title: '',
    content: '',
    duration: ''
  }
}

function createEmptyCamp() {
  return {
    date_name: '',
    campRange: [],
    camp_start: '',
    camp_end: '',
    sale_price: '',
    market_price: '',
    stock_num: 999,
    is_online: 1
  }
}

function createEmptySpecItem() {
  return {
    item_name: '',
    stock_num: 999,
    extra_price: ''
  }
}

function createEmptySpecGroup() {
  return {
    group_title: '',
    item_list: [createEmptySpecItem()]
  }
}

function createEmptyRefundRule() {
  return {
    days: '',
    deduct_rate: ''
  }
}

function createDefaultForm() {
  return {
    product_name: '',
    cover_img: [],
    product_desc: '',
    sale_start: '',
    sale_end: '',
    product_date_arr: [createEmptyCamp()],
    spec_group_arr: [createEmptySpecGroup()],
    remind_enable: 0,
    remind_days: '',
    deposit_type: 0,
    need_fields: [],
    agreement_id: '',
    notify_sms: 1,
    notify_inner: 0,
    limit_num: 0,
    refund_rule_arr: [createEmptyRefundRule()],
    is_online: 1
  }
}

export default {
  name: 'CampProductPage',
  data() {
    return {
      isEdit: false,
      productID: null,
      productIdDisplay: '-',
      stepIndex: 1,
      submitting: false,
      steps: [
        { value: 1, label: '产品详情' },
        { value: 2, label: '日期设置' },
        { value: 3, label: '下单设置' },
        { value: 4, label: '退款设置' }
      ],
      needFieldOptions: [
        { value: 'name', label: '学员姓名' },
        { value: 'gender', label: '性别' },
        { value: 'age', label: '年龄' },
        { value: 'id_card', label: '身份证号' },
        { value: 'phone', label: '家长联系电话' },
        { value: 'address', label: '家庭住址' },
        { value: 'school', label: '就读学校' },
        { value: 'height', label: '身高' },
        { value: 'weight', label: '体重' },
        { value: 'shoe_size', label: '鞋码' },
        { value: 'cert_level', label: '已取得的证书板别及级别' },
        { value: 'remark', label: '备注' }
      ],
      form: createDefaultForm(),
      itineraryDays: [
        {
          day: 1,
          list: [createEmptyItineraryRow()]
        }
      ],
      saleRange: [],
      coverFileList: [],
      uploadData: {
        token: window.sessionStorage.getItem('Token')
      },
      depositTypes: []
    }
  },
  computed: {
    pageTitle() {
      return this.isEdit ? '编辑产品' : '新增产品'
    },
    footerBtnText() {
      if (this.stepIndex < 4) return '下一步'
      return this.isEdit ? '确认保存' : '确认新增'
    },
    hideUpload() {
      return this.coverFileList.length >= 5
    },
    totalItineraryCount() {
      return this.itineraryDays.reduce((sum, d) => sum + d.list.length, 0)
    },
    campDatePickerOptions() {
      const saleStart = this.saleRange && this.saleRange[0] ? this.saleRange[0] : ''
      return {
        disabledDate(time) {
          if (!saleStart) return false
          const start = new Date(saleStart.replace(/-/g, '/'))
          start.setHours(0, 0, 0, 0)
          return time.getTime() < start.getTime()
        }
      }
    }
  },
  created() {
    this.uploadData.token = window.sessionStorage.getItem('Token')
    this.initPage()
  },
  watch: {
    '$route'(to, from) {
      if (to.path === '/campProduct' && (to.query.id !== (from && from.query && from.query.id))) {
        this.initPage()
      }
    }
  },
  methods: {
    initPage() {
      this.resetAll()
      this.uploadData.token = window.sessionStorage.getItem('Token')
      const id = this.$route.query.id
      if (id) {
        this.isEdit = true
        this.productID = id
        this.productIdDisplay = this.$route.query.no_product_ID || id || '-'
        this.loadDetail(id)
      } else {
        this.isEdit = false
        this.productID = null
        this.productIdDisplay = '-'
      }
    },
    goBack() {
      this.$router.push({ path: '/wcMall', query: { tab: '4' } })
    },
    stepClass(value) {
      if (this.stepIndex === value) return 'current'
      if (this.stepIndex > value) return 'done'
      return 'pending'
    },
    stepStatusText(value) {
      if (this.stepIndex === value) return '步骤进行中'
      if (this.stepIndex > value) return '步骤已完成'
      return '步骤未进行'
    },
    resetAll() {
      this.stepIndex = 1
      this.submitting = false
      this.form = createDefaultForm()
      this.itineraryDays = [
        {
          day: 1,
          list: [createEmptyItineraryRow()]
        }
      ]
      this.saleRange = []
      this.coverFileList = []
      this.depositTypes = []
    },
    resetCurrentStep() {
      if (this.stepIndex === 1) {
        this.form.product_name = ''
        this.form.cover_img = []
        this.form.product_desc = ''
        this.coverFileList = []
        this.itineraryDays = [
          {
            day: 1,
            list: [createEmptyItineraryRow()]
          }
        ]
      } else if (this.stepIndex === 2) {
        this.saleRange = []
        this.form.sale_start = ''
        this.form.sale_end = ''
        this.form.product_date_arr = [createEmptyCamp()]
        this.form.spec_group_arr = [createEmptySpecGroup()]
        this.form.remind_enable = 0
        this.form.remind_days = ''
      } else if (this.stepIndex === 3) {
        this.form.deposit_type = 0
        this.depositTypes = []
        this.form.need_fields = []
        this.form.agreement_id = ''
        this.form.limit_num = 0
        this.form.notify_sms = 1
        this.form.notify_inner = 0
      } else if (this.stepIndex === 4) {
        this.form.refund_rule_arr = [createEmptyRefundRule()]
        this.form.is_online = 1
      }
    },
    prevStep() {
      if (this.stepIndex > 1) {
        this.stepIndex -= 1
      }
    },
    nextOrSubmit() {
      if (!this.validateStep(this.stepIndex)) return
      if (this.stepIndex < 4) {
        this.stepIndex += 1
        return
      }
      this.submit()
    },
    validateStep(step) {
      if (step === 1) {
        if (!this.form.product_name || !String(this.form.product_name).trim()) {
          Message.error('请输入产品名称')
          return false
        }
        if (!this.form.cover_img || !this.form.cover_img.length) {
          Message.error('请上传产品主图')
          return false
        }
        if (!this.form.product_desc || !String(this.form.product_desc).trim()) {
          Message.error('请输入产品详情')
          return false
        }
        for (let d = 0; d < this.itineraryDays.length; d++) {
          const dayItem = this.itineraryDays[d]
          for (let i = 0; i < dayItem.list.length; i++) {
            const row = dayItem.list[i]
            if (!row.time_point) {
              Message.error(`请完善 DAY${dayItem.day} 第${i + 1}条行程的时间点`)
              return false
            }
            if (!row.title || !String(row.title).trim()) {
              Message.error(`请完善 DAY${dayItem.day} 第${i + 1}条行程的名称`)
              return false
            }
            if (!row.content || !String(row.content).trim()) {
              Message.error(`请完善 DAY${dayItem.day} 第${i + 1}条行程的内容`)
              return false
            }
            if (row.duration === '' || row.duration === null || row.duration === undefined) {
              Message.error(`请完善 DAY${dayItem.day} 第${i + 1}条行程的时间`)
              return false
            }
          }
        }
      }
      if (step === 2) {
        if (!this.saleRange || this.saleRange.length !== 2) {
          Message.error('请选择销售时间')
          return false
        }
        if (!this.form.product_date_arr.length) {
          Message.error('请至少添加一个营期')
          return false
        }
        for (let i = 0; i < this.form.product_date_arr.length; i++) {
          const camp = this.form.product_date_arr[i]
          if (!camp.date_name || !String(camp.date_name).trim()) {
            Message.error(`请填写营期${i + 1}名称`)
            return false
          }
          if (!camp.campRange || camp.campRange.length !== 2) {
            Message.error(`请选择营期${i + 1}时间`)
            return false
          }
          if (camp.campRange[0] < this.saleRange[0]) {
            Message.error(`营期${i + 1}开始时间不能小于销售开始时间`)
            return false
          }
          if (camp.sale_price === '' || camp.sale_price === null || camp.sale_price === undefined) {
            Message.error(`请填写营期${i + 1}销售价`)
            return false
          }
          if (camp.market_price === '' || camp.market_price === null || camp.market_price === undefined) {
            Message.error(`请填写营期${i + 1}市场价`)
            return false
          }
          if (camp.stock_num === '' || camp.stock_num === null || camp.stock_num === undefined) {
            Message.error(`请填写营期${i + 1}库存`)
            return false
          }
        }
        if (this.form.remind_enable === 1) {
          if (this.form.remind_days === '' || this.form.remind_days === null || this.form.remind_days === undefined) {
            Message.error('请填写开课提示天数')
            return false
          }
        }
        if (!this.form.spec_group_arr.length) {
          Message.error('请至少添加一个规格组')
          return false
        }
        for (let g = 0; g < this.form.spec_group_arr.length; g++) {
          const group = this.form.spec_group_arr[g]
          const hasTitle = group.group_title && String(group.group_title).trim()
          const filledItems = (group.item_list || []).filter(item => item.item_name && String(item.item_name).trim())
          if (!hasTitle) {
            Message.error(`请填写规格组${g + 1}标题`)
            return false
          }
          if (!filledItems.length) {
            Message.error(`请至少填写规格组${g + 1}的一项内容名称`)
            return false
          }
        }
      }
      if (step === 3) {
        if (!this.depositTypes.length) {
          Message.error('请选择押金设置')
          return false
        }
        if (!this.form.need_fields.length) {
          Message.error('请至少选择一项下单信息')
          return false
        }
      }
      if (step === 4) {
        for (let i = 0; i < this.form.refund_rule_arr.length; i++) {
          const rule = this.form.refund_rule_arr[i]
          if (rule.days === '' || rule.days === null || rule.days === undefined) {
            Message.error(`请填写退款档位${i + 1}天数`)
            return false
          }
          if (rule.deduct_rate === '' || rule.deduct_rate === null || rule.deduct_rate === undefined) {
            Message.error(`请填写退款档位${i + 1}扣款比例`)
            return false
          }
        }
      }
      return true
    },
    normalizeNeedFields(list) {
      if (!Array.isArray(list)) return []
      const allowed = this.needFieldOptions.map(item => item.value)
      return list.map(item => {
        if (typeof item === 'string') {
          return { field: item, required: 1 }
        }
        if (item && typeof item === 'object') {
          const field = item.field || item.key || item.value || item.name || ''
          if (!field) return null
          const required = item.required !== undefined
            ? item.required
            : (item.is_required !== undefined ? item.is_required : (item.is_must !== undefined ? item.is_must : 1))
          return {
            field,
            required: Number(required) === 1 || required === true ? 1 : 0
          }
        }
        return null
      }).filter(item => item && allowed.indexOf(item.field) > -1)
    },
    isNeedFieldChecked(field) {
      return this.form.need_fields.some(item => item.field === field)
    },
    getNeedFieldRequired(field) {
      const hit = this.form.need_fields.find(item => item.field === field)
      return hit ? Number(hit.required) : 1
    },
    toggleNeedField(field, checked) {
      const idx = this.form.need_fields.findIndex(item => item.field === field)
      if (checked) {
        if (idx === -1) {
          this.form.need_fields.push({ field, required: 1 })
        }
      } else if (idx > -1) {
        this.form.need_fields.splice(idx, 1)
      }
    },
    setNeedFieldRequired(field, required) {
      const hit = this.form.need_fields.find(item => item.field === field)
      if (hit) {
        hit.required = Number(required) === 1 ? 1 : 0
      }
    },
    // ---- 行程 ----
    addItineraryRow(dayIdx) {
      this.itineraryDays[dayIdx].list.push(createEmptyItineraryRow())
    },
    addItineraryDay() {
      const nextDay = this.itineraryDays.length
        ? this.itineraryDays[this.itineraryDays.length - 1].day + 1
        : 1
      this.itineraryDays.push({
        day: nextDay,
        list: [createEmptyItineraryRow()]
      })
    },
    removeItineraryRow(dayIdx, rowIdx) {
      if (this.totalItineraryCount <= 1) return
      const dayItem = this.itineraryDays[dayIdx]
      dayItem.list.splice(rowIdx, 1)
      if (!dayItem.list.length) {
        this.itineraryDays.splice(dayIdx, 1)
        this.itineraryDays.forEach((d, idx) => {
          d.day = idx + 1
        })
      }
    },
    // ---- 营期 ----
    addCamp() {
      this.form.product_date_arr.push(createEmptyCamp())
    },
    removeCamp(idx) {
      if (this.form.product_date_arr.length <= 1) return
      this.form.product_date_arr.splice(idx, 1)
    },
    // ---- 规格 ----
    addSpecGroup() {
      this.form.spec_group_arr.push(createEmptySpecGroup())
    },
    removeSpecGroup(idx) {
      this.form.spec_group_arr.splice(idx, 1)
      if (!this.form.spec_group_arr.length) {
        this.form.spec_group_arr.push(createEmptySpecGroup())
      }
    },
    addSpecItem(gIdx) {
      this.form.spec_group_arr[gIdx].item_list.push(createEmptySpecItem())
    },
    removeSpecItem(gIdx, iIdx) {
      const list = this.form.spec_group_arr[gIdx].item_list
      if (list.length <= 1) return
      list.splice(iIdx, 1)
    },
    // ---- 退款 ----
    addRefundRule() {
      this.form.refund_rule_arr.push(createEmptyRefundRule())
    },
    removeRefundRule(idx) {
      if (this.form.refund_rule_arr.length <= 1) return
      this.form.refund_rule_arr.splice(idx, 1)
    },
    // ---- 上传 ----
    syncCoverImg() {
      this.form.cover_img = this.coverFileList
        .map(f => f.url || (f.response && f.response.result) || '')
        .filter(Boolean)
    },
    onCoverSuccess(response, file, fileList) {
      const url = response && response.result
      if (!url) {
        Message.error('主图上传失败')
        return
      }
      file.url = url
      this.coverFileList = fileList.map(f => ({
        name: f.name,
        url: f.url || (f.response && f.response.result) || ''
      }))
      this.syncCoverImg()
    },
    onCoverRemove(file, fileList) {
      this.coverFileList = fileList.map(f => ({
        name: f.name,
        url: f.url || (f.response && f.response.result) || ''
      }))
      this.syncCoverImg()
    },
    onCoverExceed() {
      Message.error('最多上传5张产品主图')
    },
    // ---- 详情回填 ----
    loadDetail(id) {
      campProductDetail({
        token: window.sessionStorage.getItem('Token'),
        productID: id
      }).then(res => {
        if (res.data && (res.data.status === 'ok' || res.data.rcode == 200)) {
          this.fillForm(res.data.result || {})
        } else {
          Message.error((res.data && res.data.msg) || '获取产品详情失败')
        }
      }).catch(() => {
        Message.error('获取产品详情失败')
      })
    },
    fillForm(detail) {
      // 详情接口：result = { product, order_setting, product_date, itinerary, refund_rule, spec_group }
      const product = detail.product || detail
      const orderSetting = detail.order_setting || detail.orderSetting || {}

      this.form.product_name = product.product_name || ''
      this.form.product_desc = product.product_desc || ''
      this.form.is_online = product.is_online !== undefined && product.is_online !== null
        ? Number(product.is_online)
        : 1

      if (product.id) {
        this.productID = product.id
      }
      if (product.no_product_ID) {
        this.productIdDisplay = product.no_product_ID
      } else if (this.productID) {
        this.productIdDisplay = this.productID
      } else {
        this.productIdDisplay = '-'
      }

      // 封面
      let covers = product.cover_img
      if (typeof covers === 'string') {
        try {
          covers = JSON.parse(covers)
        } catch (e) {
          covers = covers ? [covers] : []
        }
      }
      if (!Array.isArray(covers)) covers = []
      this.form.cover_img = covers.filter(Boolean)
      this.coverFileList = this.form.cover_img.map((url, idx) => ({
        name: 'cover_' + (idx + 1),
        url
      }))

      // 行程
      const itinerary = detail.itinerary || detail.product_itinerary_arr || detail.product_itinerary || []
      if (Array.isArray(itinerary) && itinerary.length) {
        const dayMap = {}
        itinerary.forEach(item => {
          const day = Number(item.day) || 1
          if (!dayMap[day]) dayMap[day] = []
          dayMap[day].push({
            time_point: item.time_point || '',
            title: item.title || '',
            content: item.content || '',
            duration: item.duration !== undefined && item.duration !== null ? item.duration : ''
          })
        })
        const days = Object.keys(dayMap)
          .map(Number)
          .sort((a, b) => a - b)
          .map(day => ({
            day,
            list: dayMap[day]
          }))
        this.itineraryDays = days.length
          ? days
          : [{ day: 1, list: [createEmptyItineraryRow()] }]
      }

      // 销售时间（在 order_setting 里）
      this.form.sale_start = orderSetting.sale_start || product.sale_start || detail.sale_start || ''
      this.form.sale_end = orderSetting.sale_end || product.sale_end || detail.sale_end || ''
      if (this.form.sale_start && this.form.sale_end) {
        this.saleRange = [this.form.sale_start, this.form.sale_end]
      } else {
        this.saleRange = []
      }

      // 营期
      const dates = detail.product_date || detail.product_date_arr || []
      if (Array.isArray(dates) && dates.length) {
        this.form.product_date_arr = dates.map(item => ({
          date_name: item.date_name || '',
          campRange: item.camp_start && item.camp_end ? [item.camp_start, item.camp_end] : [],
          camp_start: item.camp_start || '',
          camp_end: item.camp_end || '',
          sale_price: item.sale_price !== undefined && item.sale_price !== null ? item.sale_price : '',
          market_price: item.market_price !== undefined && item.market_price !== null ? item.market_price : '',
          stock_num: item.stock_num !== undefined && item.stock_num !== null ? item.stock_num : 999,
          is_online: item.is_online !== undefined && item.is_online !== null ? Number(item.is_online) : 1
        }))
        const firstRemind = Number(dates[0].remind_days || 0)
        this.form.remind_enable = firstRemind > 0 ? 1 : 0
        this.form.remind_days = firstRemind > 0 ? firstRemind : ''
      }

      // 规格
      const specs = detail.spec_group || detail.spec_group_arr || []
      if (Array.isArray(specs) && specs.length) {
        this.form.spec_group_arr = specs.map(group => {
          const items = group.spec_item || group.item_list || group.spec_item_arr || []
          return {
            group_title: group.group_title || '',
            item_list: (Array.isArray(items) && items.length
              ? items
              : [createEmptySpecItem()]
            ).map(it => ({
              item_name: it.item_name || '',
              stock_num: it.stock_num !== undefined && it.stock_num !== null ? it.stock_num : 999,
              extra_price: it.extra_price !== undefined && it.extra_price !== null ? it.extra_price : ''
            }))
          }
        })
      } else {
        this.form.spec_group_arr = [createEmptySpecGroup()]
      }

      // 下单设置
      this.form.deposit_type = orderSetting.deposit_type !== undefined
        ? Number(orderSetting.deposit_type)
        : 0
      if (this.form.deposit_type === 1) {
        this.depositTypes = [1]
      } else if (this.form.deposit_type === 2) {
        this.depositTypes = [2]
      } else {
        this.depositTypes = []
      }

      let needFields = orderSetting.need_fields || []
      if (typeof needFields === 'string') {
        try {
          needFields = JSON.parse(needFields)
        } catch (e) {
          needFields = needFields ? needFields.split(',') : []
        }
      }
      this.form.need_fields = this.normalizeNeedFields(needFields)

      // 参营须知不展示，agreement_id 默认空
      this.form.agreement_id = ''

      // 信息通知不展示，固定短信通知
      this.form.notify_sms = 1
      this.form.notify_inner = 0

      // 限购不展示，固定传 0
      this.form.limit_num = 0

      // 退款
      const refunds = detail.refund_rule || detail.refund_rule_arr || []
      if (Array.isArray(refunds) && refunds.length) {
        this.form.refund_rule_arr = refunds.map(r => ({
          days: r.days !== undefined && r.days !== null ? r.days : '',
          deduct_rate: r.deduct_rate !== undefined && r.deduct_rate !== null ? r.deduct_rate : ''
        }))
      }
    },
    buildPayload() {
      const product_itinerary_arr = []
      let sort = 1
      this.itineraryDays.forEach(dayItem => {
        dayItem.list.forEach(row => {
          product_itinerary_arr.push({
            day: dayItem.day,
            time_point: row.time_point,
            title: row.title,
            content: row.content,
            duration: Number(row.duration),
            sort: sort++
          })
        })
      })

      const remindDays = this.form.remind_enable === 1 ? Number(this.form.remind_days || 0) : 0
      const product_date_arr = this.form.product_date_arr.map(camp => {
        const range = camp.campRange || []
        return {
          date_name: camp.date_name,
          camp_start: range[0] || camp.camp_start || '',
          camp_end: range[1] || camp.camp_end || '',
          sale_price: Number(camp.sale_price),
          market_price: Number(camp.market_price),
          stock_num: Number(camp.stock_num),
          remind_days: remindDays,
          is_online: Number(camp.is_online)
        }
      })

      const refund_rule_arr = this.form.refund_rule_arr.map((rule, idx) => ({
        days: Number(rule.days),
        deduct_rate: Number(rule.deduct_rate),
        sort: idx + 1
      }))

      const spec_group_arr = this.form.spec_group_arr
        .filter(group => {
          const hasTitle = group.group_title && String(group.group_title).trim()
          const hasItem = (group.item_list || []).some(item => item.item_name && String(item.item_name).trim())
          return hasTitle || hasItem
        })
        .map((group, gIdx) => ({
          group_title: group.group_title,
          sort: gIdx + 1,
          item_list: group.item_list
            .filter(item => item.item_name && String(item.item_name).trim())
            .map((item, iIdx) => ({
              item_name: item.item_name,
              stock_num: Number(item.stock_num || 0),
              extra_price: Number(item.extra_price || 0),
              sort: iIdx + 1
            }))
        }))

      const saleRange = this.saleRange || []
      const payload = {
        token: window.sessionStorage.getItem('Token'),
        product_type_id: 1,
        product_son_type_id: 2,
        category_id: 3,
        product_name: this.form.product_name,
        cover_img: this.form.cover_img.slice(),
        product_desc: this.form.product_desc,
        step_status: 9,
        is_online: Number(this.form.is_online),
        sort: 10,
        sale_start: saleRange[0] || this.form.sale_start || '',
        sale_end: saleRange[1] || this.form.sale_end || '',
        deposit_type: this.depositTypes.length === 0
          ? 0
          : (this.depositTypes.length === 1 ? Number(this.depositTypes[0]) : 2),
        limit_num: 0,
        visitor_type: 1,
        need_fields: this.form.need_fields.map(item => ({
          field: item.field,
          required: Number(item.required) === 1 ? 1 : 0
        })),
        notify_sms: 1,
        notify_inner: 0,
        product_date_arr,
        product_itinerary_arr,
        refund_rule_arr,
        spec_group_arr
      }

      if (this.isEdit && this.productID) {
        payload.productID = this.productID
      }

      return payload
    },
    submit() {
      if (!this.validateStep(4)) return
      const payload = this.buildPayload()
      this.submitting = true
      const req = this.isEdit ? campProductRedact(payload) : campProductStore(payload)
      req.then(res => {
        this.submitting = false
        if (res.data && (res.data.status === 'ok' || res.data.rcode == 200)) {
          Message.success((res.data.result && res.data.result.msg) || res.data.msg || (this.isEdit ? '保存成功' : '新增成功'))
          this.$router.push({ path: '/wcMall', query: { tab: '4' } })
        } else {
          Message.error((res.data && res.data.msg) || (this.isEdit ? '保存失败' : '新增失败'))
        }
      }).catch(() => {
        this.submitting = false
        Message.error(this.isEdit ? '保存失败' : '新增失败')
      })
    }
  }
}
</script>

<style lang="less" scoped>
.camp-product-page {
  min-height: 100%;
  background: #f5f6f8;
  padding: 0;
  box-sizing: border-box;

}

.head-card {
  background: #fff;
  border-radius: 0;
  padding: 0;
  margin-top: 12px;
}

.head-top {
  display: flex;
  align-items: center;
  position: relative;
  min-height: 48px;
  padding: 12px 24px;
  border-bottom: 1px solid #e8e8e8;
}

.head-title {
  font-size: 16px;
  font-weight: 600;
  color: #333;
  flex-shrink: 0;
}

.head-meta {
  flex: 1;
  text-align: center;
  color: #666;
  font-size: 13px;
  padding: 0 40px;
}

.head-close {
  position: absolute;
  right: 24px;
  top: 50%;
  transform: translateY(-50%);
  font-size: 18px;
  color: #999;
  cursor: pointer;
  &:hover {
    color: #246DEB;
  }
}

.step-bar {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px 24px;
}

.step-item {
  display: flex;
  align-items: center;
  flex-shrink: 0;
  color: #999;

  .step-circle {
    width: 22px;
    height: 22px;
    border-radius: 50%;
    background: #fff;
    border: 1px solid #d9d9d9;
    color: #999;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    font-size: 12px;
    line-height: 1;
    flex-shrink: 0;
    margin-right: 8px;
    box-sizing: border-box;
  }

  .step-text {
    display: flex;
    flex-direction: column;
    line-height: 1.3;
  }

  .step-label {
    font-size: 14px;
    color: #666;
  }

  .step-status {
    font-size: 12px;
    color: #999;
    margin-top: 2px;
  }

  &.current {
    .step-circle {
      background: #246DEB;
      border-color: #246DEB;
      color: #fff;
    }
    .step-label {
      color: #246DEB;
    }
  }

  &.done {
    .step-circle {
      background: #f0f0f0;
      border-color: #f0f0f0;
      color: #fff;
    }
    .step-label {
      color: #333;
    }
  }

  &.pending {
    .step-circle {
      background: #fff;
      border-color: #d9d9d9;
      color: #bfbfbf;
    }
    .step-label {
      color: #999;
    }
  }
}

.step-line {
  width: 48px;
  height: 1px;
  background: #e5e5e5;
  margin: 0 20px;
  flex-shrink: 0;

  &.done {
    background: #bfbfbf;
  }
}

.body-card {
  background: #fff;
  margin-top: 16px;
  padding: 24px 0 32px;
  box-sizing: border-box;
}

.body-inner {
  width: 62%;
  max-width: 960px;
  margin: 0 auto;
  box-sizing: border-box;
}

.camp-form {
  .tip-text {
    color: #999;
    font-size: 12px;
    line-height: 1.5;
    margin-top: 4px;
  }
  .tip-inline {
    margin-left: 10px;
  }

  /deep/ input[type='number'] {
    -moz-appearance: textfield;
  }
  /deep/ input[type='number']::-webkit-outer-spin-button,
  /deep/ input[type='number']::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }
}

.rich-editor {
  /deep/ .ql-container {
    min-height: 180px;
  }
  /deep/ .ql-editor {
    min-height: 180px;
  }
}

.step1-form {
  width: 100%;
}

.day-block {
  border: 1px solid #ebeef5;
  border-radius: 4px;
  padding: 16px;
  margin-bottom: 12px;
  background: #fafafa;

  .day-title {
    font-weight: 600;
    color: #246DEB;
    margin-bottom: 12px;
  }
}

.itinerary-grid-wrap {
  margin-bottom: 16px;
  padding-bottom: 12px;
  border-bottom: 1px dashed #e5e5e5;
  &:last-of-type {
    border-bottom: none;
  }
}

.itinerary-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 12px 24px;
}

.grid-cell {
  .grid-label {
    font-size: 13px;
    color: #666;
    margin-bottom: 6px;
  }
}

.itinerary-row-actions {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: 12px;
  margin-top: 12px;
}

.day-actions {
  display: flex;
  justify-content: flex-end;
  margin-top: 12px;
}

.step2-form,
.step3-form,
.step4-form {
  /deep/ .full-width-picker {
    width: 100%;
  }
  /deep/ .el-form-item {
    margin-bottom: 18px;
  }
  /deep/ .el-form-item__label {
    float: none;
    display: block;
    text-align: left;
    padding: 0 0 8px;
    line-height: 1.4;
  }
  /deep/ .el-form-item__content {
    margin-left: 0 !important;
  }
  /deep/ .el-input-group__append,
  /deep/ .el-input-group__prepend {
    background-color: #e5e5ea;
    color: #666;
    border-color: #dcdfe6;
  }
}

.camp-card {
  border: 1px solid #ebeef5;
  border-radius: 4px;
  padding: 12px 16px;
  margin-bottom: 12px;
  background: #fff;

  .camp-card-head {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 10px;
    font-weight: 600;
    color: #333;
  }
}

.camp-card-body {
  .camp-field + .camp-field,
  .camp-field-row + .camp-field,
  .camp-field + .camp-field-row {
    margin-top: 10px;
  }
}

.inline-label {
  flex-shrink: 0;
  width: 72px;
  color: #666;
  font-size: 14px;
  line-height: 32px;
  text-align: right;
}

.camp-field {
  display: flex;
  align-items: center;
  width: 100%;
  box-sizing: border-box;
  gap: 8px;

  > .el-input,
  > .el-date-editor,
  > .full-width-picker,
  > .el-radio-group {
    flex: 1;
    min-width: 0;
  }

  &.flex-1 {
    flex: 1;
    min-width: 0;
  }
  &.flex-2 {
    flex: 2;
    min-width: 0;
  }
  &.spec-name {
    flex: 1.5;
    min-width: 0;
  }
  &.spec-stock {
    flex: 0.9;
    min-width: 0;

    .inline-label {
      width: 40px;
    }
  }
  &.spec-fee {
    flex: 1.1;
    min-width: 0;
  }
}

.camp-field-row {
  display: flex;
  align-items: center;
  gap: 16px;

  .inline-label {
    width: 56px;
  }
  .inline-label.label-wide {
    width: 72px;
  }
}

.step2-actions {
  display: flex;
  justify-content: flex-end;
  margin-top: 12px;
}

.spec-box {
  border: 1px solid #e8e8e8;
  border-radius: 4px;
  padding: 12px 16px;
  background: #fff;
}

.spec-group {
  & + .spec-group {
    margin-top: 8px;
  }
}

.spec-item-row {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-top: 10px;
}

.spec-del-btn {
  color: #e6a23c !important;
  border-color: #e6a23c !important;
  background: #fff !important;
  flex-shrink: 0;
}

.spec-divider {
  height: 1px;
  background: #e8e8e8;
  margin: 16px 0;
}

.spec-footer {
  display: flex;
  justify-content: flex-end;
  margin-top: 16px;
  padding-top: 16px;
  border-top: 1px solid #e8e8e8;
}

.need-fields-box {
  width: 100%;
  border: 1px solid #e8e8e8;
  border-radius: 4px;
  padding: 8px 16px;
  background: #fff;
}
.need-field-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  min-height: 40px;
  padding: 4px 0;
  border-bottom: 1px solid #f2f2f2;
  &:last-child {
    border-bottom: none;
  }
  /deep/ .el-radio {
    margin-right: 16px;
  }
}

.remind-row {
  display: flex;
  align-items: center;
  gap: 24px;
  flex-wrap: wrap;
}

.remind-input {
  flex: 1;
  min-width: 220px;
}

.flex-row {
  display: flex;
  flex-wrap: wrap;
  align-items: flex-start;
  gap: 8px 16px;
}

.refund-box {
  border: 1px solid #e8e8e8;
  border-radius: 4px;
  padding: 16px 20px;
  background: #fff;
}

.refund-row {
  display: flex;
  align-items: center;
  gap: 24px;
  margin-bottom: 12px;
  flex-wrap: wrap;

  .refund-days {
    flex: 1.2;
    min-width: 260px;
  }
  .refund-rate {
    flex: 1.6;
    min-width: 280px;
  }
}

.btn-outline {
  color: #246DEB !important;
  border-color: #246DEB !important;
  background: #fff !important;
}

.danger-text {
  color: #f56c6c !important;
}

.btn-primary {
  background: #246DEB !important;
  border-color: #246DEB !important;
  color: #fff !important;
}

.footer-btns {
  display: flex;
  justify-content: flex-end;
  gap: 12px;
  margin-top: 24px;
  padding-top: 16px;
  border-top: 1px solid #f0f0f0;
}

.hide-upload {
  /deep/ .el-upload--picture-card {
    display: none;
  }
}
</style>
